// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__bRjyl","file":"styles_file__2MMkr"};